export default __webpack_public_path__ + "static/media/partner-kit.7c866412.png";